import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

// eslint-disable-next-line import/no-mutable-exports
export let loadedAnalytics: AnalyticsBrowser | null;

export const setAnalyticsBrowser = (analyticsBrowser: AnalyticsBrowser) => {
  loadedAnalytics = analyticsBrowser;
};
